export default {
  form: {
    preparation_time: {
      label: 'Enter custom time (minutes):',
      placeholder: 'Enter minutes',
    },
  },
  buttons: {
    custom: 'Custom',
  },
  feedback: {
    preparation_time_required: 'Preparation time has to be more than 0 minutes',
    min_preparation_time: 'Minimum {{minutes}} minutes as preparation time for external delivery',
    max_preparation_time: 'Maximum {{minutes}} minutes as preparation time',
  },
};
